// The generic giftnote SKU is the only one the frontend ever references.
// The backend substitutes lab-specific variants (giftnote-portland / -utah / -fuji)
// per sub-order based on the target lab of the other products in the order.
// See docs/giftnote.md.
export const GIFTNOTE_SKU = 'giftnote';

// Placed orders carry the lab variant, so display code reading orders matches the prefix.
// Never use this for cart or pricing logic, those only ever see the generic SKU.
export const isGiftnoteSku = (sku) =>
  sku === GIFTNOTE_SKU || String(sku).startsWith(`${GIFTNOTE_SKU}-`);

// Exact error string returned by POST /orders/price when the cart contains
// only a giftnote (it cannot be printed / shipped on its own). Matched verbatim
// in CartContext errorHandler to trigger a silent removal of the SKU.
export const GIFTNOTE_STANDALONE_ERROR =
  'The product giftnote cannot be purchased because it cannot be printed separately.';
